module.exports = __webpack_public_path__ + "img/camper.dfa09b52.webp";